const baseStyle = {}

const defaultProps = {}

const parts = ['content', 'trigger']

const sizes = {}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
